import { MutationTree, Mutation } from 'vuex';
import { IState, IHit, ITag, IType, ISelectedFilter, ITagOption } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);

	state.initialNumberToShow = payload.numberToShow;

	let filterArr: ITag[] = [];

	state.tags.forEach(tag => {
		filterArr.push(
			{
				title: tag.title,
				name: tag.name,
				options: tag.options
			}
		)
	})

	state.filters = filterArr;

	let selectedF: ISelectedFilter[] = [];
	state.filters.forEach(f => {
		f.options.forEach(option => {
			if(option.selected) {
				selectedF.push({
					name: f.name,
					title: f.title,
					option: {
						name: option.name,
						title: option.title,
						selected: option.selected
					}
				})
			}
		})
	})

	state.selectedFilters = selectedF;
}

const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
	state.query = payload
}

const setHitsMutation: MutationHandler<IHit[]> = (state, { payload }) => {
	state.hits = payload
}

const setTotalMutation: MutationHandler<number> = (state, { payload }) => {
	state.total = payload
}

const setNumberToShowMutation: MutationHandler<number> = (state, { payload }) => {
	state.numberToShow = payload;
}

const setLoadingMutation: MutationHandler<boolean> = (state, { payload }) => {
	state.loading = payload
}

const setSuggestionMutation: MutationHandler<string> = (state, { payload }) => {
	state.suggestion = payload
}

const setFiltersMutation: MutationHandler<ISelectedFilter> = (state, { payload }) => {
	state.filters.forEach(f => {
		if(f.name == payload.name) {
			f.options.forEach(option => {
				if(option.selected && option.name == payload.option.name) {
					option.selected = false;
				}
			})
		}
	})
}

const setSelectedFiltersMutation: MutationHandler<ISelectedFilter> = (state, { payload }) => {
	if(
			payload.option.selected && !state.selectedFilters.some(f =>
				(f.option.name == payload.option.name)
				&& (f.name == payload.name)
			)
		){
			state.selectedFilters.push(payload)
	} else {
		state.selectedFilters = state.selectedFilters.filter(f => f.option.name != payload.option.name)
	}
}

const setTypesMutation: MutationHandler<string> = (state, { payload }) => {
	state.selectedTypes = payload;
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setQuery: setQueryMutation,
	setLoading: setLoadingMutation,
	setHits: setHitsMutation,
	setTotal: setTotalMutation,
	setNumberToShow: setNumberToShowMutation,
	setSuggestion: setSuggestionMutation,
	setFilters : setFiltersMutation,
	setSelectedFilters: setSelectedFiltersMutation,
	setTypes: setTypesMutation,
}

export default mutations
